import React from "react";
import {
  DATA_TYPE_OPTIONS,
  ORGANIZATION_OPTIONS,
  SOURCE_OPTIONS,
} from "../../mock/operationsJournalMock";
import { DATA_LAYERS } from "../../constants/dataLayers";
import PeriodFilter from "../PeriodFilter/PeriodFilter";
import ExtraFilters from "../ExtraFilters/ExtraFilters";
import ColumnSettings from "../ColumnSettings/ColumnSettings";
import "../../OperationsJournal.css";

const SearchIcon = () => (
  <svg
    className="oj-search__icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="5.5" stroke="#9AA4B2" strokeWidth="1.4" />
    <path
      d="M12.5 12.5L15.5 15.5"
      stroke="#9AA4B2"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

const SelectFilter = ({ value, placeholder, options, onChange }) => (
  <select
    className="oj-select"
    value={value}
    onChange={(event) => onChange(event.target.value)}
  >
    <option value="">{placeholder}</option>
    {options.map((option) => (
      <option key={option} value={option}>
        {option}
      </option>
    ))}
  </select>
);

/**
 * Карточка фильтров журнала: поиск, период, селекты, «Добавить фильтр»
 * и панель вида (слой данных, единица, сжатый / расширенный, колонки).
 * dataViewLocked — слой зафиксирован страницей и не переключается.
 */
function JournalFilters({
  filters,
  onChange,
  onReset,
  hasActiveFilters,
  searchPlaceholder = "Поиск по документу, комментарию...",
  hideTypeAndSource = false,
  hideExtraFilters = false,
  showAccountFilter = false,
  dataView,
  onDataViewChange,
  dataViewLocked = false,
  dataViewLockedHint,
  unit,
  onUnitChange,
  viewMode,
  onViewModeChange,
  columnOrder,
  onColumnOrderChange,
}) {
  return (
    <div className="oj-filters">
      <div className="oj-filters__search-row">
        <div className="oj-search">
          <SearchIcon />
          <input
            type="text"
            className="oj-search__input"
            placeholder={searchPlaceholder}
            value={filters.searchQuery}
            onChange={(event) => onChange({ searchQuery: event.target.value })}
          />
        </div>
        <button
          type="button"
          className={`oj-reset-link${hasActiveFilters ? " is-active" : ""}`}
          onClick={onReset}
          disabled={!hasActiveFilters}
        >
          Сбросить Все
        </button>
      </div>

      <div className="oj-filters__row">
        <PeriodFilter
          dateFrom={filters.dateFrom}
          dateTo={filters.dateTo}
          onChange={({ dateFrom, dateTo }) => onChange({ dateFrom, dateTo })}
        />

        {showAccountFilter ? (
          <input
            type="text"
            className="oj-filter-input"
            placeholder="Организация"
            value={filters.organization}
            onChange={(event) => onChange({ organization: event.target.value })}
          />
        ) : (
          <SelectFilter
            value={filters.organization}
            placeholder="Организация"
            options={ORGANIZATION_OPTIONS}
            onChange={(organization) => onChange({ organization })}
          />
        )}

        {showAccountFilter && (
          <input
            type="text"
            className="oj-filter-input"
            placeholder="Код счёта Дт/Кт"
            value={filters.account}
            onChange={(event) => onChange({ account: event.target.value })}
          />
        )}

        {!hideTypeAndSource && (
          <>
            <SelectFilter
              value={filters.dataType}
              placeholder="Тип данных"
              options={DATA_TYPE_OPTIONS}
              onChange={(dataType) => onChange({ dataType })}
            />
            <SelectFilter
              value={filters.source}
              placeholder="Источник"
              options={SOURCE_OPTIONS}
              onChange={(source) => onChange({ source })}
            />
          </>
        )}

        {!hideExtraFilters && (
          <ExtraFilters
            value={filters.extraFilters}
            onChange={(extraFilters) => onChange({ extraFilters })}
          />
        )}
      </div>

      <div className="oj-filters__toolbar">
        <div className="oj-filters__toolbar-right">
          <select
            className={`oj-select oj-select--toolbar${
              dataViewLocked ? " is-locked" : ""
            }`}
            value={dataView}
            disabled={dataViewLocked}
            title={dataViewLocked ? dataViewLockedHint : undefined}
            onChange={(event) => onDataViewChange?.(event.target.value)}
          >
            {DATA_LAYERS.map((layer) => (
              <option key={layer.value} value={layer.value}>
                {layer.label}
              </option>
            ))}
          </select>

          <select
            className="oj-select oj-select--toolbar"
            value={unit}
            onChange={(event) => onUnitChange(event.target.value)}
          >
            <option value="tenge">Единица: ₸</option>
            <option value="thousand">Единица: тыс. ₸</option>
          </select>

          <div className="oj-view-toggle" role="group" aria-label="Вид таблицы">
            {[
              { id: "compact", label: "Сжатый" },
              { id: "expanded", label: "Расширенный" },
            ].map((mode) => (
              <button
                key={mode.id}
                type="button"
                className={`oj-view-toggle__btn${
                  viewMode === mode.id ? " is-active" : ""
                }`}
                onClick={() => onViewModeChange(mode.id)}
              >
                {mode.label}
              </button>
            ))}
          </div>

          {viewMode === "expanded" && (
            <ColumnSettings
              columnOrder={columnOrder}
              onChange={onColumnOrderChange}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default JournalFilters;
